import stockMovementsGetQuery from '@queries/stockMovementsGetQuery'
import { useLazyQuery, ApolloError } from '@apollo/client'
import { StockMovement } from '@typings/entities/StockMovement'
import uniq from 'lodash/uniq'

type HookReturn = {
  fetchSerialNumbers: (variables: Record<string, any>) => void
  serialNumbersListIsLoading: boolean
  serialNumbersListError?: ApolloError
  serialNumbersList: string[]
}

export const useSerialNumberForExpeditionItem = (): HookReturn => {
  const [fetchStockMovements, { data, loading, error }] = useLazyQuery(stockMovementsGetQuery)

  const serialNumbersList = uniq(
    data?.stockMovementsGet?.results?.flatMap?.((movement: StockMovement) => movement.serialNumbers).filter(Boolean) as string[],
  )

  return {
    fetchSerialNumbers: fetchStockMovements,
    serialNumbersListIsLoading: loading,
    serialNumbersListError: error,
    serialNumbersList,
  }
}
